"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _FormControlLabel = _interopRequireDefault(require("../FormControlLabel"));
var _FormHelperText = _interopRequireDefault(require("../FormHelperText"));
var _Checkbox = _interopRequireDefault(require("@mui/material/Checkbox"));
var _FormControl = _interopRequireDefault(require("@mui/material/FormControl"));
var _styles = require("@mui/styles");
var _utils = require("@mui/utils");
var _clsx = _interopRequireDefault(require("clsx"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["label", "checked", "onChange", "value", "dataCy", "data-cy-action", "data-cy-role", "LabelProps", "classes", "error", "className"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var getBgSize = function getBgSize(_ref) {
  var size = _ref.size;
  if (!size) {
    return 10;
  }
};
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      '&.Mui-checked::before': {
        content: '""',
        position: 'absolute',
        background: theme.palette.background.paper,
        height: getBgSize,
        width: getBgSize
      },
      '& .MuiSvgIcon-root': {
        position: 'relative'
      },
      '& .MuiIcon-root': {
        position: 'relative'
      }
    },
    indeterminate: {
      color: theme.palette.primary.main
    }
  };
}, {
  name: 'GgCheckbox'
});
var Checkbox = /*#__PURE__*/(0, _react.forwardRef)(function (_ref2, ref) {
  var _ref2$label = _ref2.label,
    label = _ref2$label === void 0 ? '' : _ref2$label,
    checked = _ref2.checked,
    onChange = _ref2.onChange,
    value = _ref2.value,
    dataCy = _ref2.dataCy,
    dataCyAction = _ref2['data-cy-action'],
    dataCyRole = _ref2['data-cy-role'],
    LabelProps = _ref2.LabelProps,
    classes = _ref2.classes,
    error = _ref2.error,
    className = _ref2.className,
    props = _objectWithoutProperties(_ref2, _excluded);
  var customClasses = useStyles({
    size: props.size
  });
  var control = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Checkbox["default"], _objectSpread(_objectSpread({
    color: 'primary',
    checked: checked,
    onChange: onChange,
    value: value,
    size: 'small',
    classes: _objectSpread({
      indeterminate: customClasses.indeterminate
    }, classes),
    inputProps: {
      'data-cy': dataCy,
      'data-cy-role': dataCyRole
    },
    "data-cy-action": label ? undefined : dataCyAction
  }, props), {}, {
    className: (0, _clsx["default"])(className, customClasses.root),
    ref: ref
  }));
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_FormControl["default"], {
    error: error,
    children: [label ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormControlLabel["default"], _objectSpread(_objectSpread({}, LabelProps), {}, {
      control: control,
      label: label,
      "data-cy-role": 'checkboxlabel',
      "data-cy-action": dataCyAction
    })) : control, error && /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormHelperText["default"], {
      children: error
    })]
  });
});
Checkbox.propTypes = {
  /**
   * If true, the component is checked.
   */
  checked: _propTypes["default"].bool,
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].func]),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes["default"].object,
  /**
   * The color of the component.
   * It supports those theme colors that make sense for this component.
   */
  color: _propTypes["default"].oneOf(['default', 'primary', 'secondary']),
  /**
   * 	If true, the checkbox will be disabled.
   */
  disabled: _propTypes["default"].bool,
  /**
   * 	If true, the ripple effect will be disabled.
   */
  disableRipple: _propTypes["default"].bool,
  /**
   * 	The icon to display when the component is unchecked.
   */

  icon: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].func]),
  /**
   * 	The id of the input element.
   */
  id: _propTypes["default"].string,
  /**
   * If true, the component appears indeterminate.
   * This does not set the native input element
   * to indeterminate due to inconsistent behavior across browsers.
   * However, we set a data-indeterminate attribute on the input.
   */
  indeterminate: _propTypes["default"].bool,
  /**
   * The icon to display when the component is indeterminate.
   */

  indeterminateIcon: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].func]),
  /**
   * Attributes applied to the input element.
   */
  inputProps: _propTypes["default"].object,
  /**
   * Pass a ref to the input element.
   */
  inputRef: _utils.refType,
  /**
   * 	Callback fired when the state is changed.
   */

  onChange: _propTypes["default"].func,
  /**
   * If true, the input element will be required.
   */
  required: _propTypes["default"].bool,
  /**
   * The size of the checkbox. small is equivalent to the dense checkbox styling.
   */
  size: _propTypes["default"].oneOf(['medium', 'small']),
  /**
   * The value of the component.
   * The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */
  value: _propTypes["default"].any,
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]).isRequired,
  dataCy: _propTypes["default"].string
};
var _default = exports["default"] = Checkbox;